<form class="import-organisations" [formGroup]="form">
  <div class="import-organisations__title">{{ 'components.importOrganisations.labels.title' | translate }}</div>

  <div class="import-organisations__link">
    <app-download-link [fileLink]="'assets/docs/Шаблон для импорта организаций.xlsx'">
      {{ 'components.importOrganisations.buttons.downloadTemplate' | translate }}
    </app-download-link>
  </div>

  <div class="import-organisations__form">
    <app-input-files
      tabindex="1"
      formControlName="file"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      [tuiTextfieldSize]="tuiElementSize"
      [loading]="loading"
    ></app-input-files>
  </div>

  <div class="import__buttons" [class.tui-skeleton]="loading" [class.tui-skeleton_text]="loading">
    <button tuiButton type="button" [size]="tuiElementSize" (click)="onClickSaveButton()">
      {{ 'components.importOrganisations.buttons.upload' | translate }}
    </button>
  </div>
</form>
